var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My account icon",
    clipPath: "url(#clip0_463_5615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0C18.624 0 24 5.376 24 12C24 18.624 18.624 24 12 24C5.376 24 0 18.624 0 12C0 5.376 5.376 0 12 0ZM4.82798 16.0996C6.589 18.7283 9.23413 20.4 12.1916 20.4C15.1492 20.4 17.7943 18.7283 19.5553 16.0996C17.6262 14.3006 15.0374 13.2 12.1916 13.2C9.34585 13.2 6.75714 14.3006 4.82798 16.0996ZM12 10.8C13.9883 10.8 15.6 9.18822 15.6 7.2C15.6 5.21178 13.9883 3.6 12 3.6C10.0117 3.6 8.4 5.21178 8.4 7.2C8.4 9.18822 10.0117 10.8 12 10.8Z",
    fill: "#229986"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_5615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconColor);
export default __webpack_public_path__ + "static/media/Profile_icon_color.0934089e142eb04709418882e69eaf59.svg";
export { ForwardRef as ReactComponent };